module.exports = __webpack_public_path__ + "img/iso_logo_cropped.9e7f7158.jpg";